// extracted by mini-css-extract-plugin
export var image = "_ia-0";